var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "courseTil" }, [
        _c("div", { staticClass: "img" }, [
          _c("img", {
            attrs: { src: _vm.courseDetail.imageUrl || _vm.noPic, alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "courseDetail" }, [
          _c("div", { staticClass: "titleRow" }, [
            _c("div", { staticClass: "courseTitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.courseDetail.courseName + "-" + _vm.courseDetail.name
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "courseState" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    +new Date(_vm.courseDetail.endTime) < +new Date()
                      ? "已结束"
                      : "学习中"
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "courseBadge" }, [_vm._v("省级精品课程")]),
          _vm._v(" "),
          _c("div", { staticClass: "courseTags" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/icon-school.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "所属院校: " + _vm._s(_vm.courseDetail.schoolName || "---")
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/img/icon-major.png"), alt: "" },
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "所属专业: " + _vm._s(_vm.courseDetail.majorName || "---")
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("i", { staticClass: "el-icon-stopwatch" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "学时安排: " +
                    _vm._s(_vm.courseDetail.hourAweek) +
                    " 小时每周"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "n" },
            [
              _c("el-rate", {
                attrs: {
                  disabled: "",
                  "show-score": "",
                  "text-color": "#FFB600",
                  "score-template": "{value}",
                },
                model: {
                  value: _vm.courseSpeed.evaluateScore,
                  callback: function ($$v) {
                    _vm.$set(_vm.courseSpeed, "evaluateScore", $$v)
                  },
                  expression: "courseSpeed.evaluateScore",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "t2" }, [
                _vm._v(_vm._s(_vm.courseSpeed.evaluateNumber || 0) + "人评价"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.courseSpeed.isEvaluate == true },
                  on: { click: _vm.evaluate },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.courseSpeed.isEvaluate == true ? "已评价" : "课程评价"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "courseInt" }, [
            _vm._v(
              "\n        简介：" +
                _vm._s(_vm.courseDetail.description || "无") +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "courseData flex1" }, [
            _c("div", { staticClass: "courseDate" }, [
              _c("div", { staticClass: "courseWeek flex1" }, [
                _c("div", { staticClass: "courseWeeks" }, [
                  _vm._v("\n              课程已进行至:\n              "),
                  _c("span", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.courseDetail.currentWeek) +
                        "/" +
                        _vm._s(_vm.courseDetail.week) +
                        " 周\n              "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "courseHouse" }, [
                  _vm._v("学时: " + _vm._s(_vm.courseDetail.classHour)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "courseRate" },
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.courseDetail.progress,
                      format: function () {
                        return ""
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "courseInfo flex1" }, [
                _c("div", { staticClass: "courseTime" }, [
                  _vm._v(
                    "\n              开课: " +
                      _vm._s(_vm.courseDetail.startTime) +
                      " - " +
                      _vm._s(_vm.courseDetail.endTime) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "addCourse" }, [
              _c(
                "div",
                {
                  staticClass: "courseNum",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.courseDetail.name) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn flex1" },
                [
                  +new Date(_vm.courseDetail.endTime) < +new Date()
                    ? _c(
                        "el-button",
                        {
                          staticClass: "actionBtn",
                          attrs: {
                            size: "small",
                            type: "info",
                            plain: "",
                            disabled: "",
                          },
                          on: { click: function ($event) {} },
                        },
                        [_vm._v("课程已结束")]
                      )
                    : _c(
                        "el-button",
                        {
                          staticClass: "actionBtn primaryBtn",
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.join },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.courseDetail.isJoin
                                ? "已加入课程"
                                : "加入课程"
                            )
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "actionBtn plainBtn",
                      attrs: { size: "small", type: "primary", plain: "" },
                      on: { click: _vm.collect },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.courseDetail.isCollection
                            ? "已收藏课程"
                            : "收藏课程"
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "courseStats" }, [
        _c("div", { staticClass: "statPeriod" }, [
          _c("div", { staticClass: "periodTitle" }, [
            _vm._v(_vm._s(_vm.courseDetail.name || "当前开课")),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "periodSub" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  +new Date(_vm.courseDetail.endTime) < +new Date()
                    ? "已结束"
                    : "进行中"
                ) +
                "\n        ·\n        " +
                _vm._s(_vm._f("date")(_vm.courseDetail.startTime)) +
                " - " +
                _vm._s(_vm._f("date")(_vm.courseDetail.endTime)) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statItem" }, [
          _c("div", { staticClass: "statValue" }, [
            _vm._v(_vm._s(_vm.courseDetail.peopleNumber || 0)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statLabel" }, [_vm._v("累计选修人数")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statItem" }, [
          _c("div", { staticClass: "statValue" }, [
            _vm._v(
              _vm._s(_vm.courseDetail.currentWeek || 0) +
                "/" +
                _vm._s(_vm.courseDetail.week || 0)
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statLabel" }, [_vm._v("当前进行周次")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statItem" }, [
          _c("div", { staticClass: "statValue" }, [
            _vm._v(_vm._s(_vm.courseSpeed.evaluateNumber || 0)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statLabel" }, [_vm._v("累计评价次数")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statItem" }, [
          _c("div", { staticClass: "statValue" }, [
            _vm._v(_vm._s(_vm.courseSpeed.studyTime || 0)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statLabel" }, [_vm._v("学习时长(小时)")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "courseContent flex1" }, [
        _c("div", { staticClass: "detail" }, [
          _c(
            "div",
            { staticClass: "tabs" },
            _vm._l(_vm.tabs, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  class: _vm.tabActive == i ? "active" : "tab",
                  on: {
                    click: function ($event) {
                      return _vm.changeTab(item, i)
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(item) + "\n        ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "deatailCon" }, [
            _vm.tabActive == 0
              ? _c(
                  "div",
                  { staticClass: "Introduce" },
                  [
                    _c("div", { staticClass: "til" }, [_vm._v("证书要求")]),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "til" }, [_vm._v("课程导学")]),
                    _vm._v(" "),
                    _vm.courseDetail.courseGuidance
                      ? _c("FilePreview", {
                          attrs: { fileStr: _vm.courseDetail.courseGuidance },
                        })
                      : _c("div", { staticClass: "cont" }, [
                          _c("p", [_vm._v("暂无内容")]),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "til" }, [_vm._v("成绩评定规则")]),
                    _vm._v(" "),
                    !_vm.courseDetail.courseCertificate ||
                    (_vm.courseDetail.courseCertificate &&
                      _vm.courseDetail.courseCertificate.enable == "0")
                      ? _c("div", { staticClass: "cont" }, [
                          _c("p", [_vm._v("暂无内容")]),
                        ])
                      : _c("div", { staticClass: "cont2" }, [
                          _c("p", [
                            _vm._v(
                              "同学们，本课程设置了证书哦~完成学习就可以申领证书啦~"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              如果成绩不到" +
                                _vm._s(
                                  _vm.courseDetail.courseCertificate
                                    .qualifiedScore
                                ) +
                                "分的话，没有办法获得证书。\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.courseDetail.courseCertificate.enable == "1"
                            ? _c("p", [
                                _vm._v(
                                  "\n              达到" +
                                    _vm._s(
                                      _vm.courseDetail.courseCertificate
                                        .qualifiedScore
                                    ) +
                                    "分就可以拿到合格证书啦~\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.courseDetail.courseCertificate.enable == "2"
                            ? _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.courseDetail.courseCertificate
                                        .qualifiedScore
                                    ) +
                                    "分到" +
                                    _vm._s(
                                      _vm.courseDetail.courseCertificate
                                        .excellentScore
                                    ) +
                                    "分就可以拿到合格证书啦~\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.courseDetail.courseCertificate.enable == "2"
                            ? _c("p", [
                                _vm._v(
                                  "\n              好好学习分数达到" +
                                    _vm._s(
                                      _vm.courseDetail.courseCertificate
                                        .excellentScore
                                    ) +
                                    "分以上就可以申请优秀证书啦！\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "til" }, [_vm._v("配套教材")]),
                    _vm._v(" "),
                    _vm.courseDetail.courseInfoMaterialList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cont" },
                          _vm._l(
                            _vm.courseDetail.courseInfoMaterialList,
                            function (i, j) {
                              return _c(
                                "p",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toJiaocai(i)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(j + 1) +
                                      "." +
                                      _vm._s(i.author) +
                                      "主编《" +
                                      _vm._s(i.name) +
                                      "》"
                                  ),
                                  i.press
                                    ? _c("span", [
                                        _vm._v("（" + _vm._s(i.press) + "）"),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _c("div", { staticClass: "cont" }, [
                          _c("p", [_vm._v("暂无内容")]),
                        ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabActive == 1
              ? _c("div", { staticClass: "news" }, [
                  _c("div", { staticClass: "newsList" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "list" },
                        _vm._l(_vm.noticeList, function (i) {
                          return _c(
                            "div",
                            { key: i.id, staticClass: "listItem" },
                            [
                              _c("div", { staticClass: "time" }, [
                                _c("div", { staticClass: "day" }, [
                                  _vm._v(_vm._s(_vm._f("day")(i.createTime))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "year" }, [
                                  _vm._v(_vm._s(_vm._f("year")(i.createTime))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "line" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { class: _vm.isShow === i ? "show" : "tit" },
                                [
                                  _c("span", [_vm._v(_vm._s(i.title))]),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: { innerHTML: _vm._s(i.content) },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.lookDetail(i)
                                    },
                                  },
                                },
                                [
                                  _vm.isShow === i
                                    ? _c("i", {
                                        staticClass: "el-icon-arrow-up",
                                      })
                                    : _c("i", {
                                        staticClass: "el-icon-arrow-down",
                                      }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.noticeTotal > 0
                      ? _c(
                          "div",
                          { staticClass: "paginationBlue" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                background: "",
                                "current-page": _vm.query.pageNum,
                                "page-size": _vm.query.pageSize,
                                layout: "total, prev, pager, next, jumper",
                                total: _vm.noticeTotal,
                              },
                              on: { "current-change": _vm.handleCurrentChange },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.noticeTotal == 0
                      ? _c(
                          "div",
                          {
                            staticClass: "cont",
                            staticStyle: {
                              "text-align": "center",
                              "margin-top": "50px",
                            },
                          },
                          [_c("p", [_vm._v("暂无内容")])]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabActive == 2
              ? _c(
                  "div",
                  { staticClass: "tree" },
                  [
                    _c("el-tree", {
                      ref: "courseTree",
                      attrs: {
                        data: _vm.courseTree,
                        props: _vm.defaultProps,
                        "expand-on-click-node": false,
                      },
                      on: {
                        "node-click": _vm.handleNodeClick,
                        "node-expand": _vm.handleNodeExpand,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "teacher" }, [
          _c("div", { staticClass: "courseAuth" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "conta" }, [
              _c("div", { staticClass: "img" }, [
                _c("div", { staticClass: "teaList" }, [
                  _c("img", {
                    attrs: { src: _vm.courseDetail.avatar || _vm.noImg },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.courseDetail.userName))]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "courseAuth" },
            [
              _vm._m(3),
              _vm._v(" "),
              _vm._l(_vm.courseDetail.teacherList, function (i) {
                return _c(
                  "div",
                  {
                    staticClass: "conta flex1 teaList",
                    staticStyle: { "justify-content": "flex-start" },
                  },
                  [
                    _c("div", { staticClass: "img" }, [
                      _c("div", [
                        _c("img", {
                          attrs: { src: i.teacherAvatar || _vm.noImg },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "intro" }, [
                      _c("h5", [_vm._v(_vm._s(i.teacherName))]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.courseDetail.teacherList.length == 0
                ? _c(
                    "div",
                    {
                      staticClass: "cont",
                      staticStyle: {
                        "text-align": "center",
                        "margin-top": "50px",
                      },
                    },
                    [_c("p", [_vm._v("暂无内容")])]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "课程评价（每个用户只能评价一次）",
            visible: _vm.evaluateOpen,
            width: "600px",
            "append-to-body": "",
            top: "25vh !important",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.evaluateOpen = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "课程评星:", prop: "star" } },
                [
                  _c("el-rate", {
                    staticClass: "formStar",
                    model: {
                      value: _vm.form.star,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "star", $$v)
                      },
                      expression: "form.star",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程评价:", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      rows: 5,
                      maxlength: "300",
                      "show-word-limit": "",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.evaluateSubmit("form")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.evaluateOpen = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文件预览",
            visible: _vm.filePreviewVisible,
            width: "70%",
            "append-to-body": "",
            top: "10vh !important",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.filePreviewVisible = $event
            },
          },
        },
        [
          _c("FilePreview", {
            attrs: { fileStr: _vm.fileStr, isClose: _vm.filePreviewVisible },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.downloadFile } },
                [_vm._v("下载文件")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.filePreviewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/icon-position.png"), alt: "" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("您当前位置: 专业与课程服务中心 > 课程详情")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cont" }, [
      _c("p", [_vm._v("1、完成课程内容学习。")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、完成作业、测验、考试。")]),
      _vm._v(" "),
      _c("p", [_vm._v("3、总评成绩合格。")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs" }, [
      _c("div", { staticClass: "active" }, [_vm._v("课程负责人")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs" }, [
      _c("div", { staticClass: "active" }, [_vm._v("教师团队")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }